import { createContext } from '@rc-component/context';
export var StaticContext = createContext(null);
export var GridContext = createContext(null);


//////////////////
// WEBPACK FOOTER
// ./node_modules/rc-table/es/VirtualTable/context.js
// module id = 447
// module chunks = 0